/**
 * THE OUTBOUND LINKS. ONE OWNER EACH.
 *
 * ⭐ **THE SHOP IS THE TENT.** Alex, 2026-08-18: *"the shop for revival should go to the tent on
 * wanted."* Revival has no shop of its own and is not getting one - the storefront for Revival
 * cards is the Revival Tent on the Wanted marketplace. (The `/shop` page on the old Wix site is a
 * different thing entirely, and it was deliberately dropped: *"we already said we do not want the
 * shop... for the wix site."*)
 *
 * 🚨 **THIS FILE EXISTS BECAUSE THE URL HAD TWO OWNERS AND THEY DISAGREED.** Verified 2026-08-18:
 * the menu's SHOP button went to `wanted.vendettagames.ai` (the marketplace root, every collection,
 * Revival nowhere in sight) while the post-match mint link went to `.../revival` (the Tent). Both
 * were answering the same question - *where does a Revival player go to buy and sell cards* - and a
 * player who used the menu landed somewhere they had to search. Neither was a bug that would ever
 * throw, and no gate we have compares two string literals in two files for agreement.
 *
 * ⚠️ **ADD THE NEXT SURFACE HERE, NOT INLINE.** The moment a third screen needs the Tent, an inline
 * string is a third owner and the drift starts again.
 */

/** The Revival Tent on the Wanted marketplace: where Revival cards are minted, bought and sold. */
export const TENT = "https://wanted.vendettagames.ai/revival";
